import initVueWidget from 'common/init_vue_widget'
import FeedbackPageWidget from '../vue/feedback_pages/feedback_page_widget'

const feedbackPageProps = ({
  location, rootDomain, links, leftFeedback, contactId, campaign, renderedMessageId
}) => ({
  location,
  rootDomain,
  links,
  leftFeedback,
  contactId,
  renderedMessageId,
  campaign: {
    ...campaign,
    feedbackFormItems: campaign.feedbackFormItems.map((input) => ({ ...input, key: input.title }))
  }
})

window.Styxie.Initializers.PublicFeedbackPages = {
  show(props) {
    initVueWidget('feedback-pages-widget', FeedbackPageWidget, feedbackPageProps(props))
    document.body.style.backgroundColor = props.campaign.feedbackBackgroud
  }
}
